/**
 * A promisified implementation of xmlhttprequest
 *
 * The optinos argument's usage is as follows
 * {
 *   url:    string
 *   method: post|get
 *   data:   obejct
 * }
 *
 */
export const request = function (options) {
  return new Promise((resolve, reject) => {
    if (typeof options.url === 'undefined') {
      reject('No URL was defined.')
    }

    let http = new XMLHttpRequest()
    if (!http) {
      reject('XMLHttpRequest object could not be established.')
    }

    /* Merge default optinos with the passed object */
    options = Object.assign({
      method: 'GET'
    }, options)

    let query = []
    if (options.json === true) {
      body = JSON.stringify(options.data)
    } else if (options.data) {
      body = {}
      Object.keys(options.data).forEach(key => {
        if (Array.isArray(options.data[key])) {
          query = [...query, ...options.data[key].map(i => encodeURIComponent(key) + '[]=' + encodeURIComponent(i))]
          delete options.data[key]
          return
        }
        query.push(
          encodeURIComponent(key) + '=' + encodeURIComponent(options.data[key])
        )
      })
    }

    let body = query.join('&')

    if (options.method === 'GET') {
      options.url += '?' + body
      body = null
    }

    http.open(
      options.method.toUpperCase(),
      options.url,
      true
    )

    /* Sending proper headers when the method is post */
    if (options.method.toUpperCase() === 'POST') {
      http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    }

    /* Add basic authorization header if specified */
    if (typeof options.authorization !== 'undefined') {
      http.setRequestHeader(
        'Authorization',
        'Basic ' + btoa(options.authorization.username + ':' + options.authorization.password))
    }

    http.onreadystatechange = function () {
      if (http.readyState === XMLHttpRequest.DONE) {
        if (http.status === 200) {
          if (options.raw === true) {
            resolve(http.responseText)
          } else {
            resolve(JSON.parse(http.responseText))
          }
        } else {
          reject('Request error!')
        }
      }
    }

    http.send(body)
  }) // End of the promise
}


/**
 * Populate an array with the given number
 *
 * {param} int n
 * {return} Array
 */
export const range = function (n) {
    return [...Array(n).keys()]
}